var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomePagePlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    width: 18.4,
    height: 18.4,
    rx: 9.2,
    stroke: "black",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2046 14.5772C8.53897 15.0026 7.66602 14.5246 7.66602 13.7346V7.15989C7.66602 6.36992 8.5389 5.89185 9.20454 6.31727L14.3477 9.60434C14.963 9.99756 14.963 10.8962 14.3478 11.2895L9.2046 14.5772Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePagePlayIcon);
export default __webpack_public_path__ + "static/media/HomePagePlayIcon.8b0931ac0b04c62689fbd301e0940896.svg";
export { ForwardRef as ReactComponent };